/**
 * Compare a variant name with other string
 * @param variantName: Variant name in string
 * @param toLower: Flag to know if you need to transform the variant name to lower case
 */

export const isVariantOf =
  (variantName: string, toLower = false) =>
  (toCompare: string) => {
    const variantNameParsed = toLower ? variantName.toLowerCase() : variantName;
    const reg = new RegExp(`^${variantNameParsed}`, 'i');
    return reg.test(toCompare);
  };

export enum ComponentsVariants {
  CARD = 'card',
  PORTAL_CAROUSEL = 'portalCarousel',
  RTC = 'rtc',
  WELCOME_MESSAGE = 'welcomeMessage',
  MY_BUSINESS = 'myBusiness',
  HORIZONTAL_BUTTON_SET = 'horizontalButtonSet',
  TWO_COLUMN = 'twoColumn',
  TABBED_LIST = 'tabbedList',
  TABBED_DOCUMENT_PICKER = 'tabbeddocumentpicker',
  TAB_LIST = 'tabList',
  TABBED_LIST_CONTENT = 'tabbedListContent',
  FORM_PICKER = 'formPicker',
  DOCUMENT_PICKER = 'documentPicker',
  TOGGLE_MENU = 'toggleMenu',
  ACCORDION_GROUP = 'accordionGroup',
  POWER_APPS = 'powerapps',
  ES_TABBED_CONTENT = 'esTabbedContent',
  RICH_TEXT = 'RichText',
}
